/* eslint angular/log: 0 */
/** Used here intentionally. */

/* eslint no-unused-vars: 0 */
/** Parameters in logging methods are used through JavaScript's `arguments` property. */

/**
 * @typedef {Object} LoggerFactory
 *
 * @property {function} createLogger Initialises an instance of {Logger}
 * that can be safely used within an isolated module.
 */

/**
 * @typedef {Object} Logger
 *
 * @property {function} console
 * @property {function} log
 * @property {function} info
 * @property {function} error
 * @property {function} warn
 * @property {function} debug
 * @property {function} test
 * @property {function} ok
 */

(function() {
    'use strict';

    angular.module( APP_ID )
        .factory( 'LoggerFactory', [ '$log', 'LogEntriesService', 'App', LoggerFactory ]);


    /**
     * Provides a decorator for customised logging.
     *
     * @param {ng.ILogService} $log
     * @param {LogEntriesService} LogEntriesService
     * @param {App} App
     *
     * @returns {LoggerFactory}
     */
    function LoggerFactory( $log, LogEntriesService, App ){





        /* ===== PRIVATE MEMBERS ============================================ */


        var service = {
            createLogger:  createLogger
        };



        /**
         * Decorates logging messages to improve their readability and
         * identification. It also allows future extension of general
         * logging capabilities (eg. to implement remote logging).
         *
         * @param {string} entityId Identification of the object that emits the
         * logs.
         * @param {boolean} shouldLogInstantiation Whether or not logger should
         * create a log record on its instantiation.
         * @param {Object} configurationObject Configuration properties
         * enabling more granular tweaking of logging capabilities.
         */
        function Logger( entityId, shouldLogInstantiation, configurationObject ) {





            /* ===== PRIVATE MEMBERS ======================================== */


            /** @type {enum} */
            var DEFAULT_LOGGING_PATTERN;


            /** @type {string} */
            var id;


            /** @type {number} */
            var testLogCounter = 0;





            /* ===== RUN ON INSTANTIATION =================================== */


            /** @constructor */
            (function construct(){
                shouldLogInstantiation = angular.isUndefined( shouldLogInstantiation ) ? true : shouldLogInstantiation;
                id = entityId || '-';

                DEFAULT_LOGGING_PATTERN = '[' + id + '] ';
                if ( shouldLogInstantiation ) logInstantiation();
            })();





            /* ===== EXPOSE TO THE SERVICE ================================== */


            this.console = logToConsole;
            this.log     = log;
            this.info    = logInfo;
            this.error   = logError;
            this.warn    = logWarning;
            this.debug   = logDebug;
            this.test    = logTest;
            this.ok      = logOk;





            /* ===== PUBLIC METHODS ========================================= */


            function logToConsole( msg ) {
                arguments[ 0 ] = DEFAULT_LOGGING_PATTERN + arguments[ 0 ];
                console.log.apply( null, arguments );
            }

            function log( msg ) {
                arguments[ 0 ] = DEFAULT_LOGGING_PATTERN + arguments[ 0 ];
                $log.log.apply( null, arguments );
            }

            function logInfo( msg ) {
                arguments[ 0 ] = DEFAULT_LOGGING_PATTERN + arguments[ 0 ];
                $log.info.apply( null, arguments );
            }

            function logError( msg ) {
                arguments[ 0 ] = DEFAULT_LOGGING_PATTERN + arguments[ 0 ];
                $log.error.apply( null, arguments );

                if ( App.isPublicMode() ) logErrorRemotely.apply( null, arguments );
            }

            function logWarning( msg ) {
                arguments[ 0 ] = DEFAULT_LOGGING_PATTERN + arguments[ 0 ];
                $log.warn.apply( null, arguments );

                if ( App.isPublicMode() ) logWarnRemotely.apply( null, arguments );
            }

            function logDebug( msg ) {
                arguments[ 0 ] = DEFAULT_LOGGING_PATTERN + arguments[ 0 ];
                $log.debug.apply( null, arguments );
            }


            /**
             * Logs order of this log call and highlights.
             */
            function logTest( msg ) {
                var args = Array.prototype.slice.call( arguments );

                args[ 0 ] = '%c (%s.) ' + DEFAULT_LOGGING_PATTERN + args[ 0 ];
                args.splice( 1, 0, 'font-weight: bold', ++testLogCounter );

                $log.debug.apply( null, args );
            }


            /**
             * Logs a successful message.
             */
            function logOk( msg ) {
                if ( App.isPublicMode() ){
                    return;
                }

                var args = Array.prototype.slice.call( arguments );

                args[ 0 ] = '%c' + args[ 0 ];
                args.splice( 1, 0, 'color: green' );

                $log.log.apply( null, args );
            }





            /* ===== PRIVATE METHODS ======================================== */


            function logInstantiation() {
                $log.debug( ' ✓ instantiating %s...', id );
            }



            // Logs error message to LogEntries (logentries.com) in correct format
            function logWarnRemotely() {
                LogEntriesService.warn.apply( null, getArgumentsWithStringsSubstituted.apply( null, arguments ) );
            }

            function logErrorRemotely() {
                LogEntriesService.error.apply( null, getArgumentsWithStringsSubstituted.apply( null, arguments ) );
            }



            /**
             * Substitutes all placeholders `%s` found in given string - works
             * similarly to internals of console.log().
             *
             * @returns {Array<any>} List of parameters (will be passed
             *                       to remote logging function)
             */
            function getArgumentsWithStringsSubstituted() {
                var args    = Array.prototype.slice.call( arguments ),
                rep         = args.slice( 1, args.length ),
                i           = 0;

                var output      = args[ 0 ].replace(/%s/g, function( match, idx ) {
                  var subst=rep.slice(i, ++i);
                  return( subst );
                });

                var newArgs = args.slice( i + 1, args.length );
                newArgs.splice( 0, 0, output );

                return newArgs;
            }


        }



        ////////////////////////////////////////////////////////////////////////

        return service; // Expose API

        ////////////////////////////////////////////////////////////////////////





        /* ===== PUBLIC METHODS ============================================= */


        /**
         * Creates and returns a {Logger} instance.
         *
         * @param {string} ID
         * @param {boolean} logInitialisation
         * @param {Object} options
         *
         * @returns {Logger}
         */
        function createLogger( ID, logInitialisation, options ) {
            return new Logger( ID, logInitialisation, options );
        }


    };
})();
